var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import { accountBackIcon } from '../../../../images/icon';
import pubsub from "@viewlift/pubsub";
var Popup = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var children = _a.children, enableBtns = _a.enableBtns, title = _a.title, description = _a.description, confirmHandler = _a.confirmHandler, cancelHandler = _a.cancelHandler, backHandler = _a.backHandler, _t = _a.shouldClosePopUpAfterConfirm, shouldClosePopUpAfterConfirm = _t === void 0 ? true : _t, show = _a.show, contentExtraPadding = _a.contentExtraPadding, contentAlignment = _a.contentAlignment, confirmCTA = _a.confirmCTA, cancelCTA = _a.cancelCTA, isComponent = _a.isComponent, Component = _a.Component, options = _a.options, _u = _a.showSelectInput, showSelectInput = _u === void 0 ? false : _u, selectInputConfig = _a.selectInputConfig, _v = _a.showTextBox, showTextBox = _v === void 0 ? false : _v, textareaConfig = _a.textareaConfig, message = _a.message, _w = _a.messageAlignment, messageAlignment = _w === void 0 ? "left" : _w, errorList = _a.errorList, termsOfService = _a.termsOfService;
    var _x = __read(useState(false), 2), showPopup = _x[0], setShowPopup = _x[1];
    var _y = __read(useState({
        isError: false,
        errMsg: ''
    }), 2), error = _y[0], setError = _y[1];
    var _z = __read(useState(""), 2), selectInputValue = _z[0], setSelectInputValue = _z[1];
    var _0 = __read(useState(""), 2), textareaValue = _0[0], setTextareaValue = _0[1];
    var isSelectInputNotSelected = (showSelectInput && !selectInputValue) ? true : false;
    var confirmRef = useRef(null);
    var backRef = useRef(null);
    useEffect(function () {
        setShowPopup(show);
    }, [show]);
    var toggleShowHidePopup = function (flag) {
        setShowPopup(flag);
    };
    var handleConfirm = function () {
        if (shouldClosePopUpAfterConfirm)
            toggleShowHidePopup(false);
        if (confirmHandler)
            confirmHandler();
    };
    var handleCancel = function () {
        toggleShowHidePopup(false);
        if (cancelHandler)
            cancelHandler();
    };
    var buttonCtaColor = (_f = (_e = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.cta) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.backgroundColor;
    var buttonCtaTextColor = (_l = (_k = (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsMain) === null || _h === void 0 ? void 0 : _h.brand) === null || _j === void 0 ? void 0 : _j.cta) === null || _k === void 0 ? void 0 : _k.primary) === null || _l === void 0 ? void 0 : _l.textColor;
    var handlePopupError = function (data) {
        var code = data;
        var err = 'Something went wrong';
        if (errorList === null || errorList === void 0 ? void 0 : errorList["".concat(code)])
            err = errorList["".concat(code)];
        setError({ isError: true, errMsg: err });
    };
    useEffect(function () {
        pubsub.subscribe("popup-error", handlePopupError);
    }, []);
    useEffect(function () {
        if (showPopup)
            window.addEventListener('keyup', handleKeyPress);
        else
            window.removeEventListener('keyup', handleKeyPress);
        return function () { return window.removeEventListener('keyup', handleKeyPress); };
    }, [showPopup]);
    var handleKeyPress = function (e) {
        var _a;
        if (e.key === "Enter") {
            if (confirmRef === null || confirmRef === void 0 ? void 0 : confirmRef.current)
                confirmRef.current.click();
        }
        if (e.key === "Escape") {
            (_a = backRef === null || backRef === void 0 ? void 0 : backRef.current) === null || _a === void 0 ? void 0 : _a.click();
            var otpBackBtn = document.getElementById("otp-back-btn");
            if (otpBackBtn) {
                otpBackBtn.click();
            }
        }
    };
    var handleSelect = function (e) {
        var _a, _b;
        selectInputConfig === null || selectInputConfig === void 0 ? void 0 : selectInputConfig.selectHandler((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        setSelectInputValue((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value);
    };
    var handleTextarea = function (e) {
        var _a, _b;
        textareaConfig === null || textareaConfig === void 0 ? void 0 : textareaConfig.textareaHandler((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        setTextareaValue((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value);
    };
    return React.createElement(React.Fragment, null, showPopup && React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'popup-container' },
            React.createElement("div", { className: 'popup-holder' },
                React.createElement("div", { className: 'popup-wrapper popup-dialog' },
                    !isComponent && !((_m = options === null || options === void 0 ? void 0 : options.deleteConfig) === null || _m === void 0 ? void 0 : _m.isMessage) && React.createElement("div", { className: 'back-btn', ref: backRef, onClick: function () {
                            if (backHandler) {
                                return backHandler();
                            }
                            toggleShowHidePopup(false);
                            if (cancelHandler)
                                cancelHandler();
                        } },
                        accountBackIcon(),
                        React.createElement("div", null, ((_q = (_p = (_o = window === null || window === void 0 ? void 0 : window.app_data) === null || _o === void 0 ? void 0 : _o.appcmsMain) === null || _p === void 0 ? void 0 : _p.genericMessages) === null || _q === void 0 ? void 0 : _q.backCta) || "Back")),
                    !isComponent ?
                        React.createElement("div", { className: contentExtraPadding ? 'popup-content extra-padding' : 'popup-content', style: { textAlign: contentAlignment || 'start' } },
                            (title || description) && React.createElement("div", { className: 'disclaimer-holder' },
                                React.createElement("div", { className: 'disclaimer-title site-cta-color' }, title),
                                React.createElement("div", { className: 'disclaimer-description' }, description)),
                            React.createElement("div", { className: 'child' }, children)) : React.createElement(Component, __assign({}, options)),
                    message && React.createElement("div", { className: 'message', style: { textAlign: messageAlignment || "center" } }, message),
                    showSelectInput && (selectInputConfig === null || selectInputConfig === void 0 ? void 0 : selectInputConfig.options) &&
                        React.createElement("div", { className: 'select-container' },
                            React.createElement("select", { id: "select", name: "select", value: selectInputValue, onChange: handleSelect },
                                (selectInputConfig === null || selectInputConfig === void 0 ? void 0 : selectInputConfig.placeHolderText) && React.createElement("option", { value: "", disabled: true, selected: true }, selectInputConfig === null || selectInputConfig === void 0 ? void 0 : selectInputConfig.placeHolderText), (_r = selectInputConfig === null || selectInputConfig === void 0 ? void 0 : selectInputConfig.options) === null || _r === void 0 ? void 0 :
                                _r.map(function (option, idx) { return React.createElement("option", { key: idx, value: option === null || option === void 0 ? void 0 : option.value }, option === null || option === void 0 ? void 0 : option.title); }))),
                    showTextBox &&
                        React.createElement("div", { className: 'textarea-container' },
                            React.createElement("textarea", { id: "textarea", name: "textarea", value: textareaValue, placeholder: textareaConfig === null || textareaConfig === void 0 ? void 0 : textareaConfig.placeHolderText, rows: textareaConfig === null || textareaConfig === void 0 ? void 0 : textareaConfig.rows, onChange: handleTextarea })),
                    (error === null || error === void 0 ? void 0 : error.isError) ? React.createElement("div", { className: 'error-msg' }, error === null || error === void 0 ? void 0 : error.errMsg) : React.createElement(React.Fragment, null),
                    enableBtns && React.createElement("div", { className: 'btn-holder' },
                        React.createElement("button", { ref: confirmRef, onClick: function () { return handleConfirm(); }, id: "confirm-btn", "aria-label": "Confirm", className: "confirm-btn btn ".concat(isSelectInputNotSelected ? "disable" : ""), disabled: isSelectInputNotSelected ? true : false }, confirmCTA || "Confirm"),
                        ((_s = options === null || options === void 0 ? void 0 : options.deleteConfig) === null || _s === void 0 ? void 0 : _s.isDelete) ? React.createElement(React.Fragment, null) : React.createElement("button", { onClick: function () { return handleCancel(); }, "aria-label": "Cancel", className: 'cancel-btn btn' }, cancelCTA || "Cancel")),
                    termsOfService && (React.createElement("div", { className: "terms-container" },
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: termsOfService } }))))))));
};
export default Popup;
